import { useEffect, useState } from "react";
import { ImageIcon, Loader2 } from "lucide-react";
import { api } from "../lib/api";

// Loads an authorized receipt image as a blob (img tags can't send auth headers).
export function ReceiptImage({ fileId, className, alt = "Receipt" }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    if (!fileId) return;
    setUrl(null);
    setError(false);
    api
      .get(`/files/${fileId}/download`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => active && setError(true));
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (!fileId || error)
    return (
      <div className={`flex items-center justify-center bg-secondary text-muted-foreground ${className}`}>
        <ImageIcon className="h-6 w-6 opacity-40" />
      </div>
    );
  if (!url)
    return (
      <div className={`flex items-center justify-center bg-secondary ${className}`}>
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    );
  return <img src={url} alt={alt} className={className} loading="lazy" />;
}
